import React from 'react';
import { useRedo } from './useRedo';
import { useUndo } from './useUndo';

export const useHandleKeyCombinations = () => {
  const handleRedo = useRedo();
  const handleUndo = useUndo();

  const handleKeyDown = (event: React.KeyboardEvent) => {
    const { key, metaKey, ctrlKey, target } = event;

    if ((target as HTMLElement).nodeName === 'INPUT') return;

    const isCombination = metaKey || ctrlKey;

    if (isCombination && key === 'y') {
      event.preventDefault();
      handleRedo();
    }

    if (isCombination && key === 'z') {
      event.preventDefault();
      handleUndo();
    }
  };

  React.useEffect(() => {
    // @ts-expect-error: just ignore for now.
    window.addEventListener('keydown', handleKeyDown);

    // @ts-expect-error: just ignore for now.
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleRedo, handleUndo]);
};
